import { CSSProperties } from 'react';
import { Else, If, Then } from 'react-if';
import cns from 'classnames';
import { useTranslation } from 'next-i18next';
import { CheckIcon } from '@zep/icons';
import { OwnedSpace } from '@zep/types';
import { ZepApp } from '../../../../services';
import S from './ContentSelectionGrid.module.scss';

/**
 * 맵이나 앱, 게임을 업로드할 때 타겟이 되는 맵이나 앱을 선택하는 UI
 */
const ContentSelectionGrid = ({
  contents,
  selectedContentHashId,
  onContentSelect,
  disabled,
  isAppContent,
  aspectRatio = '1/1'
}: StoreContentUploadGridProps) => {
  /**
   * 스페이스 클릭시 상위 컴포넌트로 스페이스 ID를 전달하기 위한 함수
   * @param hashId 클릭한 스페이스의 Hash ID
   */
  const {
    t
  } = useTranslation(['store']);
  const handleContentClick = (hashId: string) => {
    if (!disabled) {
      onContentSelect?.(hashId);
    }
  };
  return contents?.length ? <div className={cns(S.content_upload_grid, {
    [S.app_content]: isAppContent
  })} style={{
    '--grid-aspeat-ratio': aspectRatio
  } as CSSProperties} data-sentry-component="ContentSelectionGrid" data-sentry-source-file="ContentSelectionGrid.tsx">
      {contents.map(content => <div className={cns(S.content_item, {
      [S.disabled_click]: disabled
    })} key={content.hashId} onClick={() => handleContentClick(content.hashId)}>
          <div className={S.content_image_wrapper}>
            <img className={S.content_thumbnail_image}
        // @ts-ignore
        src={content.thumbnailUrl || content.finalIconUrl} alt={content.name} />
            {selectedContentHashId === content.hashId && <div className={S.selected_area}>
                <CheckIcon width={70} height={70} />
              </div>}
          </div>
          {/*{isAppContent && <p className={S.content_id}>{content.id}</p>}*/}
          <p className={S.content_name}>{content.name}</p>
        </div>)}
    </div> : <div className={S.empty_section} data-sentry-component="ContentSelectionGrid" data-sentry-source-file="ContentSelectionGrid.tsx">
      <img width={64} height={44} src="/images/light/assetStore/three_dot_bubble.png" alt="empty-icon" />
      <label className={S.empty_section_label}>
        <If condition={isAppContent} data-sentry-element="If" data-sentry-source-file="ContentSelectionGrid.tsx">
          <Then data-sentry-element="Then" data-sentry-source-file="ContentSelectionGrid.tsx">
            {String(t('store:store_empty_app'))}
            <br />
            {String(t('store:store_make_app_information'))}
          </Then>
          <Else data-sentry-element="Else" data-sentry-source-file="ContentSelectionGrid.tsx">
            {String(t('store:store_empty_map'))}
            <br />
            {String(t('store:store_make_map_information'))}
          </Else>
        </If>
      </label>
    </div>;
};
export default ContentSelectionGrid;
export type StoreContentUploadGridProps = {
  contents: ZepApp[] | OwnedSpace[];
  selectedContentHashId?: string;
  onContentSelect?: (contentHashId: string) => void;
  disabled?: boolean;
  isAppContent?: boolean;
  aspectRatio?: string;
};